let actions = {
    setBaseUrl: (context, data) => {
        context.commit('setBaseUrl', data);
    },
}
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/baseUrl/actions.js